export default "__VITE_ASSET__Cyj$IltM__"